import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  border-bottom: 1px solid var(--gray-200);
  margin-bottom: 1.5rem;
  overflow-x: auto;
  overflow-y: hidden;
`;

const ProfileNavigation: FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ProfileNavigation;
